/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align whitespace quotemark */

import {
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ViewContainerRef
}                                 from '@angular/core';

import { DocumentWindow }         from './document.window';
import { DocumentWindowManager }  from './document.window.manager';
import { Logger }                 from '@/util/logger';



import * as $                     from 'jquery';

import {Subscription}             from 'rxjs';
import {ResizeObserver}           from 'resize-observer';
import {DocumentMetadata}         from '@/screens/ide/document.metadata';
import {ServiceManager}           from "@/services/service.manager";
import {BatchView}                from "@/screens/ide/batchviewer/batch.view";
import {BatchViewerMetadata}      from "@/screens/ide/batch.viewer.metadata";
import {BatchViewerComponent}     from "@/components/batch.viewer.component";

/**
 *
 * @class BatchViewerWindow
 *
 * window for viewing and monitoring batches
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class BatchViewerWindow extends DocumentWindow {

  /** access to the various services */
  private services:      ServiceManager = null;

  /** the document manager we are a tab  of */
  private manager: DocumentWindowManager = null;

  /** the SWE batch ID */
  private batchId: string                = '';

  /** the folder the batch is in */
  private root: string                   = '';

  /** name of the batch */
  private name: string                   = '';

  /** are editing or monitoring? */
  private mode: BatchView                = BatchView.EDIT;

  /** the Angular component that is the actual batch view panel component...which we are hosting */
  private viewer: BatchViewerComponent   = null;

  /** the resizer tracker */
  private resizeObserver: ResizeObserver = null;

  /** the observable we use to know when the component is ready */
  private readySub: Subscription;

  /** standard constructor */
  constructor(
    meta: BatchViewerMetadata,
    manager: DocumentWindowManager
  ) {

    super(manager, meta, manager.layoutManager());

    Logger.debug('[BatchViewerWindow] constructing...');

    this.services = manager.serviceManager();
    this.manager  = manager;
    this.batchId  = meta.batchId;
    this.root     = meta.root;
    this.name     = meta.name;
    this.mode     = meta.mode;

    this.initViewer();
  }

  /** fetch my metadata */
  public myMeta(): BatchViewerMetadata {

    return this.meta as BatchViewerMetadata;
  }

  /** restore the view (on current 'focus') */
  public initViewer() {

    Logger.debug(`[BatchViewerWindow] => `, this.meta);

    const bvw: BatchViewerWindow = this;

    const container: JQuery<HTMLElement> = $(`#${this.meta.id}`);

    if (!$(container) || !$(container).is('div')) {

      this.unReady();

      Logger.error(`[BatchViewerWindow] missing hosting container (${bvw.meta.id})!`);

      return ;
    }

    $(container).html(`
<div id="batch_viewer_${bvw.meta.id}" class="batchviewerpanelshell">
</div>
`);

    /*
     * wait for the HTML to actually update with the component selector above, this won't create the
     * component, its just HTML :)  But, we can use Angular's component factory etc. to create the
     * component and effective "host" an Angular component inside our DocumentWindow (which isn't
     * Angular based).
     *
     */

    const checkExist = setInterval(() => {

      const dom: HTMLElement = document.getElementById(`batch_viewer_${bvw.meta.id}`) as HTMLElement;

      if (!dom) {

        return;
      }

      clearInterval(checkExist);

      Logger.debug(`[BatchViewerWindow] inject batch viewer component ...`);

      const    view: ViewContainerRef         = bvw.services.ide.view;
      const factory: ComponentFactoryResolver = bvw.services.ide.componentResolver;


      const creator      = factory.resolveComponentFactory(BatchViewerComponent);
      const componentRef = view.createComponent(creator);

      bvw.viewer        = componentRef.instance  as BatchViewerComponent;

      const domElem      = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

      /* ensure the new component is parented under our container */

      dom.appendChild(domElem);

      /*
       * add a self watch for changes in wrapper size...because sometime it will change because
       * the panels around it have changed in size...not because the browser has changed in size;
       * that is, its not a window resize event, so that kind of size change wouldn't normally
       * be caught.
       *
       */

      bvw.resizeObserver = new ResizeObserver(entries => {

        bvw.viewer.resize();

      });

      bvw.resizeObserver.observe( dom );

      this.viewer.reloaded = () => {

        Logger.debug(`[BatchViewerWindow] child content changed...`);


      };

      Logger.debug(`[BatchViewerWindow]  component is ready, setting batch...`);

      bvw.viewer.manager  = bvw.manager;
      bvw.viewer.window   = bvw;

      this.readySub = bvw.viewer.ready.subscribe((status: boolean) => {

        if (status == false) {

          return;
        }

        /* do any init still remaining before we go live ... */

        bvw.viewer.finalize();

        /* go ahead and do the first time load */

        bvw.refocus(this.meta);

        /* register this window in its anchor group, first one is always the anchor. */

        if (bvw.manager.anchor(bvw.type) == null) {

          /*
           * there is no anchor yet, so use this one; we always default to the most
           * recently created window.
           *
           */

          bvw.manager.dropAnchor(bvw.type, bvw);
          bvw.viewer.dropAnchor();
        }

      });

    }, 100);
  }

  /** after initialization, some windows may allow for resetting to new content to view */
  public refocus(meta: DocumentMetadata) {

    if (this.viewer == null) {

      return ;
    }

    Logger.debug(`[BatchViewerWindow] loading: `, meta);

    this.meta = meta;

    /* on demand loading of a tree */

    this.viewer.refocus(this.myMeta());

    /* update our title if needed */

    this.updateFocus();
  }

  public close(implied: boolean = false) {

    Logger.debug(`[BatchViewerWindow] closing!`);

    if (this.viewer != null) {

      this.viewer.close();

      this.viewer = null;
    }

    if (this.resizeObserver != null) {

      this.resizeObserver.disconnect();

      this.resizeObserver = null;
    }

    this.readySub.unsubscribe();

    super.close(implied);
  }

  /** update the focus to current */
  private updateFocus() {

    Logger.debug(`[BatchViewerWindow] focus updating...`);

    this.title = this.myMeta().name;

  }

}
